import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { get_all_user_submissions } from '../../redux/actions/submissionActions'
import Loader from '../../components/Loader'
import Pagination from '../../components/Pagination'
import { GrFormView } from 'react-icons/gr'
import {
	ADMIN_GET_ALL_SUBMISSIONS_RESET,
	GET_CURRENT_CAMPAIGN_RESET,
} from '../../redux/types'

const DashboardSubmissions = () => {
	const dispatch = useDispatch()

	const [selected, setSelected] = useState('')
	// const [tagged, setTagged] = useState("");
	// const [buildingType, setBuildingType] = useState("");
	// const [category, setCategory] = useState("");
	// const [points, setPoints] = useState("");
	const [keyword, setKeyword] = useState('')

	const pageNumber = new URLSearchParams(useLocation().search).get('page') || 1

	const categoryHead = ['S/N', 'User', 'Title', 'Campaign', 'View']

	const getAllSubmissions = useSelector((state) => state.getAllSubmissions)
	const { loading, submissions } = getAllSubmissions

	let i = 0

	// const filterHandler = (e) => {
	// 	e.preventDefault();
	// 	dispatch(
	// 		get_locations(
	// 			pageNumber,
	// 			selected,
	// 			tagged,
	// 			points,
	// 			buildingType,
	// 			category,
	// 			keyword
	// 		)
	// 	);
	// };

	// const searchHandler = (e) => {
	// 	e.preventDefault();
	// 	dispatch(
	// 		get_locations(
	// 			pageNumber,
	// 			selected,
	// 			tagged,
	// 			points,
	// 			buildingType,
	// 			category,
	// 			keyword
	// 		)
	// 	);
	// };

	useEffect(() => {
		dispatch(
			get_all_user_submissions(
				pageNumber,
				selected
				// keyword
			)
		)

		return () => {
			dispatch({ type: GET_CURRENT_CAMPAIGN_RESET })
			dispatch({ type: ADMIN_GET_ALL_SUBMISSIONS_RESET })
		}
	}, [dispatch, pageNumber, selected])

	return (
		<>
			<div>
				<div className='row justify-content-center mb-5'>
					<div className='col-md-11 mt-5'>
						{/* <div className="row mb-3">
							<div className="col-md-6"></div>
							<div className="col-md-6">
								<input
									type="input"
									placeholder="search"
									className="site-form"
									onChange={(e) => setKeyword(e.target.value)}
									onInput={searchHandler}
								/>
							</div>
						</div> */}
						{/* <div className="filter-div">
							<div className="row ">
								<div className="col-md-3 col-sm-4 col-6">
									<select
										value={selected}
										onChange={(e) =>
											setSelected(e.target.value)
										}
										className="form-select mb-3"
									>
										<option value="">Status</option>
										<option value=''>All</option>
										<option value="active">Active</option>
										<option value="pending">Pending</option>
										<option value="deleted">Deleted</option>
									</select>
								</div>
							</div>
						</div> */}

						{loading ? (
							<Loader />
						) : (
							<>
								{submissions && submissions.submissions.length > 0 ? (
									<div className='table-responsive shadow-sm'>
										<table className='table table-bordered table-striped'>
											<thead className=''>
												<tr>
													{categoryHead.map((cate, i) => (
														<th key={i}>{cate}</th>
													))}
												</tr>
											</thead>
											<tbody>
												{submissions.submissions.map((l, i) => (
													<tr key={l._id}>
														<td>{(submissions.meta.page - 1) * 10 + i + 1}</td>
														<td>
															{l.createdBy.firstName} {l.createdBy.lastName}
														</td>
														<td>{l.title}</td>
														<td>{l.submissionRound.name}</td>
														<td>
															<Link
																to={`/admin/dashboard/submissions/${l.title}`}
															>
																<GrFormView size={20} />
															</Link>
														</td>
													</tr>
												))}
											</tbody>
										</table>
									</div>
								) : (
									<div className='card'>
										<div className='card-body'>
											<p className='nothing'>No Submissions found</p>
										</div>
									</div>
								)}
								{submissions && submissions.meta && submissions.meta.pages > 1 && (
									<>
										<Pagination
											currentPage={Number(submissions.meta.page)}
											totalCount={Number(submissions.meta.total)}
											pageSize={10}
											pathname={'/admin/dashboard/submissions'}
										/>
									</>
								)}
							</>
						)}
					</div>
				</div>
			</div>
		</>
	)
}

export default DashboardSubmissions
